import { createCtx } from '@shared/util/context';

export interface CardUpdatesActions {
  // Registers one card query's refetch under a caller-stable id, or unregisters it with `null`.
  setRefetch: (id: string, refetch: (() => void) | null) => void;
  // Offers the customer a refetch of every registered card query.
  setHasCardUpdates: (hasCardUpdates: boolean) => void;
}

// Card queries outside a collection view (the card modal's lists, the view builder) have no toast
// to offer a refetch through, so they get these no-ops.
const noCardUpdates: CardUpdatesActions = {
  setRefetch: () => {},
  setHasCardUpdates: () => {},
};

export const [useCardUpdatesActions, CardUpdatesActionsProvider] =
  createCtx<CardUpdatesActions>(noCardUpdates);
